document.addEventListener('DOMContentLoaded', () => {
  const sidebarRefurbishmentOpen = document.querySelector('.sustainability-explore-button');
  if (sidebarRefurbishmentOpen) {
    sidebarRefurbishmentOpen.addEventListener('click', (e) => {
      e.stopPropagation();
      const sidebarOpen = document.getElementById('sidebar-cart-open');
      if (sidebarOpen) {
        sidebarOpen.click();
      }
      document.body.classList.add('sidebar-open');
    });
  }
});
